var map = {
	"./major-ticket.webp": "./src/assets/images/major-ticket.webp",
	"./mini-ticket.webp": "./src/assets/images/mini-ticket.webp",
	"./minor-ticket.webp": "./src/assets/images/minor-ticket.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*\\-ticket\\.webp$";